import React from 'react'
import Pagination from '../../common/Pagination/Pagination'
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import find from "lodash/find";
import { Button } from '../../common/Button/Button';
import { toast } from 'react-toastify';
import copysvg from "../../assets/arrow_copy.svg"

const ReactTableFixedColumns = withFixedColumns(ReactTable);

const ESPUmcReportingTable = (props) => {

    const data = [
        {
            sBusinessCity: 'Pune',
            sContactNumber: '8104459479',
            sEmailAddress: 'rakesh@conveniotech.com',
            sFirstName: "Rakesh",
            sLastName: '',
            sCatalogue: "Yes",
            sBusinessName: 'Testing Name 1',
            sBusinessSector: 'Others',
            sTag: '["Custom Service", "Specialized Service"]'
        },
        {
            sBusinessCity: 'Haveli',
            sContactNumber: '8104459479',
            sEmailAddress: 'rakesh@conveniotech.com',
            sFirstName: "Rakesh",
            sLastName: 'Sankrani',
            sCatalogue: "No",
            sBusinessName: 'Testing',
            sBusinessSector: 'beauty',
            sTag: '["Face Care", "Fragrance"]'
        }
    ]

    const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

    const columns = [
        {
            id: 'checkbox',
            Header: (
                <input
                    type="checkbox"
                    onChange={props.handleSelectAll}
                    checked={
						// props.data
						// 	.filter(service => service.custrefSRState !== 'Delivered' && service.custrefSRState !== 'Cancelled')
						// 	.every(user => props.selectedUsers.includes(user.nUserId))

                        props.data
							.every(user => props?.selectedUsers?.includes(user.nUserId))
					}
					// disabled={
					// 	props.data.every(service => service.custrefSRState === 'Delivered' || service.custrefSRState === 'Cancelled')
					// }
                />
            ),
            width: 50,
            accessor: '',
            Cell: ({ original }) => (
                <input
                    type="checkbox"
                    onChange={() => props.handleCheckboxChange(original.nUserId)}
                    checked={props.isSelected(original.nUserId)}
					// disabled={original.custrefSRState === 'Delivered' || original.custrefSRState === 'Cancelled'}
                />
            )
        },
        {
			id: "sFirstName",
			Header: "Customer Name",
			headerStyle: { 'whiteSpace': 'normal', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sFirstName",
			Cell: ({ original }) => (
				<div className='text-center'>
					<div className={"conv-float-left conv-mr5"}>
						{
							original.bNeedToTalkToSP ? (<><div className={"blue-dot"}></div><br></br></>) : ("")
						}
						{
							original.sExternalHHEmail ? (<><div className={"green-dot"}></div></>) : ("")
						}
					</div>
					{
						`${original.sFirstName ?
							original.sFirstName :
							original.customer_meta ?
								original.customer_meta.first_name :
								""
						}${' '}
						${original.sLastName ?
							original.sLastName :
							original.customer_meta ?
								original.customer_meta.last_name :
								""
						}`
					}
				</div>
			),
		},
		{
			id: "sEmailAddress",
			Header: "Customer Email ID",
			headerStyle: { 'whiteSpace': 'normal', 'wordBreak': 'break-all', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sEmailAddress",
			Cell: ({ original }) => (
				<div className='text-center'>
							<span style={{
                                'whiteSpace': 'normal', 'wordBreak': 'break-all',
                            }}>
								{
									original.sEmailAddress
								}
							</span>
				</div>
			),
		},
		{
			id: "sContactNumber",
			Header: "Phone No.",
			width: 140,
			headerStyle: { 'whiteSpace': 'unset', 'borderBottom': 'solid 1px #ccc' },
			accessor: "sContactNumber",
			Cell: ({ original }) => (
				<div className='text-center'>
				{/* <span onClick={() => getUserDetails(original)}>
					{
						original.sContactNumber
					}
					</span> */}

							<span>
								{
									original.sContactNumber
								}
							</span>
                            <img
											alt="copy"
											src={copysvg}
											height={"20px"}
											width={"16px"}
											className="con-cursor-pointer conv-mr13 conv-ml10"
											onClick={(e) => {
												e.preventDefault();
												copyToClipboard(original.sContactNumber);
												toast(`${original.sFirstName ?
													original.sFirstName :
													original.customer_meta ?
														original.customer_meta.first_name :
														""
													}${' '}
							${original.sLastName ?
														original.sLastName :
														original.customer_meta ?
															original.customer_meta.last_name :
															""
													}'s Contact Copied!`, {
													autoClose: 5000,
													type: toast.TYPE.SUCCESS,
												});
											}}
										/>
				</div>
			)
		},
        {
            id: 'sBusinessName',
            Header: 'Business Name',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "sBusinessName",
            Cell: ({ value }) => <div className='text-center'>{value}</div>
        },
        {
            id: 'sBusinessCity',
            Header: 'Business City',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "sBusinessCity",
            Cell: ({ value }) => <div className='text-center'>{value}</div>
        },
        {
            id: 'sCatalogue',
            Header: 'Catlogue - Yes / No',
            width: 100,
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "sCatalogue",
            Cell: ({ value, row }) => <div className='text-center'>
                {value === 'Yes' ? (
                    <a href='#' style={{textDecoration: 'underline', color: '#78417C'}} onClick={(original) => props.handleCatalogueClick(row)}>Yes</a>
                ) : (
                    'No'
                )}
            </div>
        },
        {
            id: 'sBusinessSector',
            Header: 'Sector',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "sBusinessSector",
            Cell: ({ value }) => <div className='text-center'>{value}</div>
        },
        {
            id: 'sTag',
            Header: 'Tags',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "sTag",
            Cell: ({ value }) => <div className='text-center'>{processTags(value)}</div>
        },
        {
            id: 'OppuAwailedCount',
            Header: 'Opp Availed',
            style: { 'whiteSpace': 'unset' },
            headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
            accessor: "OppuAwailedCount",
            width: 100,
            Cell: ({ value, row }) => <div className='text-center'>
                {value !== 0 ?
                <span onClick={() => props.onOppAvailedCountClick(row._original)} style={{textDecoration: 'underline', color: "#75287C"}}>
                    {value}
                </span>
            :
            value}
            </div>
        },

    ]

    const processTags = (tags) => {
        if(tags !== null && tags !== '[]'){
            let parsedTags = [];
    
            try {
                // Replace single quotes with double quotes to make it valid JSON
                const validJsonString = tags.replace(/'/g, '"');
                parsedTags = JSON.parse(validJsonString);
            } catch (error) {
                console.error("Invalid JSON:", error);
                return "";
            }
        
            // Ensure parsedTags is an array
            if (!Array.isArray(parsedTags)) {
                console.error("Parsed value is not an array");
                return "";
            }
        
            return parsedTags.join(', ');
        }
    };

    console.log(props.data, ">>>>>data in UMC Customers ESPUMCReportingTable");
    console.log(props.isSelected, ">>>>>props.isSelected");
    console.log(props?.selectedUsers, ">>>>props?.selectedUsers");
    
  return (
      <div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">
          <div className="spled-container">
              <div className="service-partner spled-container">
                  <ReactTableFixedColumns
                      minRows={0}
                      data={props.data || []}
                      columns={columns}
                      manual
                      defaultPage={props.page}
                      pages={props.pages}
                      page={props.page}
                      pageSize={props.pageSize}
                      sortable={false}
                      defaultPageSize={10}
                      showPagination={true}
                      pageSizeOptions={[10, 20, 30, 50, 75, 100]}
                      onFetchData={(state, instance) => {
                          props.onFetchServiceRequests(instance, false);
                      }}
                      onPageSizeChange={props.onPageSizeOptionChange}
                    //   PaginationComponent={Pagination}
                      PaginationComponent={(paginationProps) => (
                          <Pagination
                              {...paginationProps}
                              displayRecordCount={props?.displayRecordCount}
                          />
                      )}
                      style={{ overflowY: "initial", height: "75vh" }}
                      className="-striped hide-scrollbar"
                  />
              </div>
          </div>
      </div>
  )
}

export default ESPUmcReportingTable
